import { Link, useLocation } from 'react-router-dom';
import { ChartLine } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useApp } from '../AppProvider.tsx';
import useAppLocation from '../useAppLocation.ts';
import type { NavLinkProps } from '@fastnorth/kraken/components/navigation';
import useRacesWithStatistics from '../useRacesWithStatistics.tsx';

const useStatisticsLink = (): NavLinkProps | null => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.components.navigation' });
  const [{ event, lastSelectedRace }] = useApp();
  const { uniqueCode } = event || {};
  const { isStatistics } = useAppLocation();
  const { search } = useLocation();

  const racesWithStatistics = useRacesWithStatistics();

  if (!event || !racesWithStatistics.length) {
    return null;
  }

  return {
    id: 'statistics',
    active: isStatistics,
    children: (
      <Link
        to={`/events/${uniqueCode}/race/${encodeURIComponent(String(lastSelectedRace || racesWithStatistics[0]?.id))}/statistics${search}`}
        className={'flex items-center'}
        data-dd-action-name={'link-statistics-nav_menu'}>
        <ChartLine size={16} strokeWidth={2} className={'mr-4'} />
        {t('statistics_label')}
      </Link>
    ),
  };
};

export default useStatisticsLink;
